<h4 class="title configurator-subtitle mt-4">
  {{ 'closet-doors.door-configuration.opening-percentage' | translate }}
</h4>

@if (closetDoorsService.panelGroups.length === 0) {
  <ng-casto-loader></ng-casto-loader>
}

@for (group of closetDoorsService.panelGroups; track group.percentage) {
  <fieldset class="panel-group">
    <legend class="title configurator-subtitle">{{ group.percentage }} %</legend>
    <p class="custom-form-row form-checkbox">
      @for (panel of group.panels; track panel.panelCount) {
        <span>
          <input
            type="radio"
            [(ngModel)]="current.closetDoors.doorNumber"
            [id]="'panel-count-' + panel.panelCount"
            name="door-number"
            (change)="selectPanel(panel.panelCount)"
            [value]="panel.panelCount" />
          <label [for]="'panel-count-' + panel.panelCount">
            {{ panel.panelCount }} {{ 'closet-doors.door-configuration.doors' | translate }}
          </label>
        </span>
      }
    </p>
  </fieldset>
}
